<template>
  <div
    class="overflow-hidden py-10 lg:py-28"
    :class="data.background === 'gray' ? 'bg-gray-200' : 'bg-white'"
  >
    <div class="container grid-default">
      <Heading
        :semantic="isSemantic"
        :level="level"
        class="col-span-6 mb-6 text-3xl font-light text-blue-950 lg:col-start-2 lg:col-end-11 lg:mb-20 lg:text-6xl"
      >
        {{ data.title }}
      </Heading>
      <div ref="sectionRef" class="col-span-6 lg:col-span-12">
        <LazyPositions v-if="isSectionVisible" :data="data.positionslot" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionPositionRecord } from '~/types/generated'

const props = defineProps({
  data: {
    type: Object as PropType<SectionPositionRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

const sectionRef = ref<HTMLElement | null>(null)
const isSectionVisible = ref(false)

const { stop } = useIntersectionObserver(
  sectionRef,
  ([{ isIntersecting }], _observerElement) => {
    if (isIntersecting) {
      isSectionVisible.value = true
    }
  },
  {
    threshold: 0
  }
)

onUnmounted(() => {
  stop()
})
</script>
